import type { ReactNode } from "react";

import AuthSplitLayout from "./AuthSplitLayout";

type ScreenManagerLayoutProps = {
  children?: ReactNode;
};

/**
 * Shared layout for all screen managers (dev and prod).
 * Chrome (language selector, logo, product image) is rendered once here.
 */
export default function ScreenManagerLayout({
  children,
}: ScreenManagerLayoutProps) {
  return <AuthSplitLayout>{children}</AuthSplitLayout>;
}
